import * as React from "react"
import { IconProps } from "./IconProps"

export const FastForward = (props: IconProps) => {
  const { color = "currentColor" } = props

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5626_11566)">
        <path
          d="M5.58984 7.41L10.1798 12L5.58984 16.59L6.99984 18L12.9998 12L6.99984 6L5.58984 7.41ZM15.9998 6H17.9998V18H15.9998L15.9998 6Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
